var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-page',{attrs:{"title":"Ussd suppliers","breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('supplier-list')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }